import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../services/common.service';
@Pipe({
    name: 'objectToDisplayString',
    standalone: false
})
export class ObjectToDisplayPipe implements PipeTransform {
    language: any;

    constructor(private commonService: CommonService) {}

    transform(item: any, displayObject: any, langKey: string): any {
        let result = '';
        if (item && displayObject) {
            let keys = Object.keys(displayObject);
            keys.forEach(key => {
                let isCheckKey = false;
                if (displayObject[key] === 'date') {
                    let order = new Date(item[key]);
                    if (result !== '') {
                        result += ' - ';
                    }
                    result = result + order.getDate() + '.' + (order.getMonth() + 1) + '.' + order.getFullYear();
                } else if (displayObject[key] === 'complex') {
                    if (result !== '') result += ' - ';
                    let keyy = item[key.split('.')[0]][key.split('.')[1]];
                    result = result + 'Status : ' + this.commonService.getKeyToTranslate(keyy);
                    isCheckKey = true;
                } else if (!isCheckKey) {
                    if (result !== '') result += ' - ';
                    result = result + item[key];
                }
            });
        }
        return result;
    }
}
